import { render, staticRenderFns } from "./porderxz.vue?vue&type=template&id=1d9c82a2&scoped=true&"
import script from "./porderxz.vue?vue&type=script&lang=js&"
export * from "./porderxz.vue?vue&type=script&lang=js&"
import style0 from "./porderxz.vue?vue&type=style&index=0&id=1d9c82a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9c82a2",
  null
  
)

export default component.exports